module.exports = __webpack_public_path__ + "static/media/MoveInOutCompLogo.425ea4f9.svg";